// Secure token storage utility
class TokenStorage {
  constructor() {
    this.ACCESS_TOKEN_KEY = 'auth_access_token';
    this.REFRESH_TOKEN_KEY = 'auth_refresh_token';
    this.USER_KEY = 'auth_user';
  }

  // Store tokens and user info
  setTokens(accessToken, refreshToken, user = null) {
    try {
      // For security, consider encrypting tokens before storage
      sessionStorage.setItem(this.ACCESS_TOKEN_KEY, accessToken);
      localStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken);
      if (user) {
        sessionStorage.setItem(this.USER_KEY, JSON.stringify(user));
      }
    } catch (error) {
      console.error('Error storing tokens:', error);
    }
  }

  // Get access token
  getAccessToken() {
    try {
      return sessionStorage.getItem(this.ACCESS_TOKEN_KEY);
    } catch (error) {
      console.error('Error getting access token:', error);
      return null;
    }
  }

  // Get refresh token
  getRefreshToken() {
    try {
      return localStorage.getItem(this.REFRESH_TOKEN_KEY);
    } catch (error) {
      console.error('Error getting refresh token:', error);
      return null;
    }
  }

  // Get cached user info
  getUser() {
    try {
      const user = sessionStorage.getItem(this.USER_KEY);
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Error getting user:', error);
      return null;
    }
  }

  // Clear all tokens and user info
  clearTokens() {
    try {
      sessionStorage.removeItem(this.ACCESS_TOKEN_KEY);
      localStorage.removeItem(this.REFRESH_TOKEN_KEY);
      sessionStorage.removeItem(this.USER_KEY);
    } catch (error) {
      console.error('Error clearing tokens:', error);
    }
  }

  // Check if tokens exist
  hasValidTokens() {
    return !!(this.getAccessToken() && this.getRefreshToken());
  }
}

export const tokenStorage = new TokenStorage();
